import { useEffect, useRef } from "react";

export function usePrevious<T>(value: T, initialValue?: T): T | undefined {
  const ref = useRef<T | undefined>(initialValue); // Create a ref to store the previous value

  useEffect(() => {
    ref.current = value; // Update the ref's current value after render
  }, [value]); // Re-run effect only when 'value' changes

  return ref.current; // Return the value from the previous render
}
